<div class="sa-mfa-popup flex-center flex-col">
    <div class="sa-mfa-popup-logo">
        <img src="../assets/mfa-popup.jpg" alt="MFA" height="307px" width="397px">
    </div>
    <div class="sa-mfa-popup-title flex-center flex-col ">
        <p class="title">Please log out and log back in to set up MFA</p>
        <p class="sub-title sa-mfa-popup-description text-center">MFA setup is only available for a limited time after login, and your window has expired. Please log out, log back in, and set it up</p>
    </div>
    <div class="sa-mfa-popup-actions flex-center">
        <sa-button id="cancle" type="outline" text="Cancel" size="large" state="default" width="174px" (click)="backToProducts()"></sa-button>
        <sa-button id="logout" type="primary" text="Log Out" size="large" state="error" width="174px" (click)="logout()"></sa-button>
    </div>
</div>